<template>
    <div class="sustainable-component wage-evaluate-referencepositions">

        <!-- <div class="bg-success mb-3 p-3 rounded">vue component wage-evaluate-referencepositions</div>-->
        <!--
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-md-6">
                <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-5">Befattning</th>
                            <th class="col-5">Riktarbete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in jobPositions" :key="index">
                            <td>
                                <span v-if="selected != item">{{item.Name}}</span>
                            </td>
                            <td class="p-0">
                                <span v-if="selected != item">
                                    <v-checkbox density="compact" v-model="item.ReferencePosition" hide-details></v-checkbox>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <v-btn size="default" color="primary" class="btn-primary" @click="saveReferencePositions">
                    Spara
                </v-btn>
            </div>
        </div>
    </div>
        -->
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-evaluate-referencepositions',
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async load() {
                this.jobPositions = await WageService.getReferencePositions();
            },
            async saveReferencePositions() {
                await WageService.saveReferencePositions(this.jobPositions);
            }
        },
        data() {
            return {
                jobPositions: [],
            };
        },
        watch: {

        },
        mounted() {
            this.load();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
